<template>
  <div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import {
  mapActions,
  mapState,
  mapMutations
} from "vuex";
export default {
  name: 'app',
  data() {
    return {
      
    }
  },
  created() {
    this.init()
  },
  methods: {
    ...mapActions({
      getConfigCompany: "index/getConfigCompany",
    }),
    init(){
      this.getConfigCompany({
        data:{},
        success:(res) => {
          if(res.code == 1){
            localStorage.setItem('company',JSON.stringify(res.data))
          }
        },
      })
    }
  }
  
}
</script>

<style>
    
</style>
